// extracted by mini-css-extract-plugin
export var dataCell = "_k9-2";
export var dataRow = "_k9-0";
export var headerRow = "_k9-1";